import request from '@/utils/request'
import URL from './urlTranslator'

export function getSeaPortList(params) {
  return request({
    url: URL.seaport.portList,
    method: 'get',
    params
  })
}

export function loadTemplatePort(likeName) {
  const params = { likeName }
  return request({
    url: URL.seaport.templatePortList,
    method: 'get',
    params
  })
}

/**
 * 港口查询
 * @param likeName
 * @param tenantId
 */
export function loadAllSeaPort(params) {
  return request({
    url: URL.seaport.loadSeaPort,
    method: 'get',
    params
  })
}

export function addTemplatePort2Tenant(data) {
  return request({
    url: URL.seaport.addTenantPort,
    method: 'post',
    data
  })
}

export function addPlatformPort(data) {
  return request({
    url: URL.seaport.addPlatformPort,
    method: 'post',
    data
  })
}

export function updatePort(data) {
  return request({
    url: URL.seaport.port,
    method: 'put',
    data
  })
}

export function batchDelSeaPort(uuidList, codes) {
  const data = { uuidList, codes }
  return request({
    url: URL.seaport.port,
    method: 'delete',
    data
  })
}

export function getPortDetail(uuid) {
  const params = { uuid }
  return request({
    url: `${URL.seaport.portDetail}`,
    method: 'get',
    params
  })
}

export function switchSeaPortStatus(id, bActive) {
  const params = { id: id }
  const url = bActive ? URL.dmn.seaPortInfoEnable : URL.dmn.seaPortInfoDisable
  return request({
    url: url,
    method: 'put',
    params
  })
}

export function getEdiPortList(params) {
  return request({
    url: URL.seaport.ediPort,
    method: 'get',
    params
  })
}

export function saveEdiPort(data) {
  return request({
    url: URL.seaport.ediPort,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delEdiPort(uuid) {
  return request({
    url: URL.seaport.ediPort + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 获取根据代码、名称模糊查询海运港口amsPort
export function getSeaAmsPortList(params) {
  return request({
    url: URL.seaport.amsPort,
    method: 'get',
    params
  })
}

// 获取海运所有amsPort
export function getSeaAllAmsPort() {
  return request({
    url: URL.seaport.getAllAmsPort,
    method: 'get'
  })
}

// 获取uuid删除海运港口amsPort
export function deleteSeaAmsPort(uuid) {
  return request({
    url: `${URL.seaport.amsPort}/${uuid}`,
    method: 'delete'
  })
}

// 获取uuid删除海运港口amsPort
export function addSeaAmsPort(data) {
  return request({
    url: `${URL.seaport.amsPort}`,
    method: 'post',
    data
  })
}

// 获取uuid删除海运港口amsPort
export function editSeaAmsPort(data) {
  return request({
    url: `${URL.seaport.amsPort}`,
    method: 'put',
    data
  })
}

// 批量更新AmsPort状态
export function batchUpdateAmsPortStatus(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: `${URL.seaport.batchUpdateAmsPortStatus}`,
    method: 'put',
    data
  })
}

// 检验接收方是否维护对应的港口
export function isHavePorts(tenantId, codes) {
  return request({
    url: URL.seaport.isHavePorts,
    method: 'post',
    data: codes,
    params: { tenantId }
  })
}

export function getPortCodeByMapping(params) {
  return request({
    url: URL.sys.getEdiMapping,
    method: 'get',
    params
  })
}
